// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {NotificationService, SimRecorderService, SimSystemExtendedService} from "@services";
import {Scenario, TrainingSession} from "@models";
import {FormArray, FormControl, Validators} from "@angular/forms";
import {Router} from "@angular/router";

export interface DialogData_ContinueTrainingSessionDialogInput extends MatDialogDataBaseInput {
	sessionToBeContinued: TrainingSession;
	webRecorderMappingId: string;
}

export interface DialogData_ContinueTrainingSessionDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-continue-trainingsession-dialog",
	templateUrl: "./continue-trainingsession-dialog.component.html",
	styleUrls: ["./continue-trainingsession-dialog.component.scss"],
	standalone: false,
})
export class ContinueTrainingsessionDialogComponent extends BasicMaterialDialog<
	ContinueTrainingsessionDialogComponent,
	DialogData_ContinueTrainingSessionDialogInput,
	DialogData_ContinueTrainingSessionDialogOutput
> {
	public scenarioFC = new FormArray<FormControl<Scenario>>([], [Validators.required]);

	constructor(
		private _simSystemService: SimSystemExtendedService,
		_injector: Injector,
		private _simRecorderService: SimRecorderService,
		private _router: Router,
		private _simNotificationService: NotificationService,
	) {
		super(_injector);

		//this._simRecorderService.continueTrainingSession({});
	}

	continueTrainingSession() {
		this._simRecorderService
			.continueTrainingSession({
				trainingSessionId: this.data.sessionToBeContinued.id,
				scenarioId: this.scenarioFC.value[0]?.id || null,
				recorderMappingId: this.data.webRecorderMappingId,
			})
			.then((continueTrainingSessionRes) => {
				if (continueTrainingSessionRes?.success) {
					this._router.navigate(["/simrecorder/default/", continueTrainingSessionRes.trainingSession.id]).then(() => {
						this.close({action: "ok"});
					});
				} else {
					this._simNotificationService.notifyError("Could not continue TrainingSession");
				}
			});
	}
}
